module.exports = __webpack_public_path__ + "static/media/icon-zoom.f6089341.svg";